module.exports = __webpack_public_path__ + "static/media/CPTT11.ed2a2635.png";